import { render, staticRenderFns } from "./MultiLangQuill.vue?vue&type=template&id=7d2995e7&"
import script from "./MultiLangQuill.vue?vue&type=script&lang=js&"
export * from "./MultiLangQuill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports